import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import arrowRight from "../../../assets/img/components/arrow-right.webp";
import arrowLeft from "../../../assets/img/components/arrow-left.webp";
import truck from "../../../assets/img/about/aboutThree/truck.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const timelineSlides = [
  { year: "2011", className: "card1",  titleKey: "about_three_2011_title", textKey: "about_three_2011_text" },
  { year: "2012", className: "card2",  titleKey: "about_three_2012_title", textKey: "about_three_2012_text" },
  { year: "2013", className: "card3",  titleKey: "about_three_2013_title", textKey: "about_three_2013_text" },
  { year: "2014", className: "card4",  titleKey: "about_three_2014_title", textKey: "about_three_2014_text" },
  { year: "2015", className: "card5",  titleKey: "about_three_2015_title", textKey: "about_three_2015_text" },
  { year: "2016", className: "card6",  titleKey: "about_three_2016_title", textKey: "about_three_2016_text" },
  { year: "2017", className: "card7",  titleKey: "about_three_2017_title", textKey: "about_three_2017_text" },
  { year: "2018", className: "card8",  titleKey: "about_three_2018_title", textKey: "about_three_2018_text" },
  { year: "2019", className: "card9",  titleKey: "about_three_2019_title", textKey: "about_three_2019_text" },
  { year: "2020", className: "card10", titleKey: "about_three_2020_title", textKey: "about_three_2020_text" },
  { year: "2021", className: "card11", titleKey: "about_three_2021_title", textKey: "about_three_2021_text" },
  { year: "2022", className: "card12", titleKey: "about_three_2022_title", textKey: "about_three_2022_text" },
  { year: "2023", className: "card13", titleKey: "about_three_2023_title", textKey: "about_three_2023_text" },
  { year: "2024", className: "card14", titleKey: "about_three_2024_title", textKey: "about_three_2024_text" },
];

const breakpoints = {
  1400: { slidesPerView: 4 },
  1000: { effect: "none", slidesPerView: 3 },
  700:  { effect: "none", slidesPerView: 2 },
  0:    { effect: "none", slidesPerView: 1 },
};

function AboutThree() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isClicked, setClicked] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div className={`aboutThree ${isVisible ? "visible" : ""}`}>
        <div className="aboutThreeTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("about_three_title")}
          </h1>
        </div>
        <Swiper
          breakpoints={breakpoints}
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          slidesPerView={2}
          speed={200}
        >
          <div className="swiper-button-prev">
            <img src={arrowLeft} width={"35px"} alt="" />
          </div>
          <img
            className={`truck ${isClicked ? "truckActive" : ""}`}
            src={truck}
            alt=""
            width={"150px"}
          />
          {timelineSlides.map(({ year, className, titleKey, textKey }) => (
            <SwiperSlide key={className}>
              <div className={`${className} card ${isVisible ? "visible" : ""}`}>
                <div className="cardContent">
                  <h2>{year}</h2>
                  <h3>{t(titleKey)}</h3>
                  <p>{t(textKey)}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-button-next" onClick={() => setClicked(!isClicked)}>
            <img src={arrowRight} width={"35px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default AboutThree;
